module.exports = __webpack_public_path__ + "img/mega-menu-mediclub.5b37d98.svg";